import React from 'react';

const UserShield = ({ size = 16, color = '#fff' }: { size?: string | number; color?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_157_2026)">
        <path
          d="M11.2672 11.8677L10.9607 11.2547C10.8223 10.9779 10.6096 10.745 10.3463 10.5823C10.083 10.4196 9.77955 10.3334 9.47003 10.3334H6.53014C6.22061 10.3334 5.9172 10.4196 5.65391 10.5823C5.39061 10.745 5.17783 10.9779 5.03942 11.2547L4.7345 11.8646M9.66675 7.00005C9.66675 7.92053 8.92056 8.66672 8.00008 8.66672C7.07961 8.66672 6.33341 7.92053 6.33341 7.00005C6.33341 6.07958 7.07961 5.33339 8.00008 5.33339C8.92056 5.33339 9.66675 6.07958 9.66675 7.00005ZM13.3334 8.3473C13.3334 10.8638 10.2368 12.7331 8.76016 13.4837C8.52528 13.6038 8.26529 13.6665 8.00149 13.6667C7.7377 13.667 7.4776 13.6047 7.24251 13.485C5.76683 12.7352 2.66675 10.8612 2.66675 8.3473V4.71295C2.66912 4.54837 2.73156 4.39033 2.84232 4.26857C2.95308 4.14681 3.10452 4.06973 3.26815 4.05183C4.68276 3.94434 6.03898 3.44278 7.18315 2.60399C7.41926 2.42828 7.70574 2.33337 8.00007 2.33337C8.29439 2.33337 8.58087 2.42828 8.81699 2.60399C9.96115 3.44278 11.3174 3.94434 12.732 4.05183C12.8956 4.06972 13.0471 4.1468 13.1578 4.26856C13.2686 4.39032 13.331 4.54837 13.3334 4.71295V8.3473Z"
          stroke={color}
          strokeOpacity="0.8"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_157_2026">
          <rect width={size} height={size} fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UserShield;
